import { render } from "./TmsLastErrorCard.vue?vue&type=template&id=ff9427fc&scoped=true"
import script from "./TmsLastErrorCard.vue?vue&type=script&lang=js"
export * from "./TmsLastErrorCard.vue?vue&type=script&lang=js"

import "./TmsLastErrorCard.vue?vue&type=style&index=0&id=ff9427fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff9427fc"]])

export default __exports__